import React, { useState, useEffect } from 'react';

/* Collapsible drawer for per-module settings.
   Pass `title` and any children to render inside.
   `forceOpen` — when the sidebar routes the user straight to this
   drawer via `activeSection`, flip to open automatically (matches the
   Settings `<Section/>` behaviour). Prevents the "click submodule →
   still collapsed" head-scratch. */
export default function SettingsDrawer({ title = 'Module settings', defaultOpen = false, forceOpen = false, children, badge }) {
  const [open, setOpen] = useState(defaultOpen || forceOpen);
  useEffect(() => {
    if (forceOpen) setOpen(true);
  }, [forceOpen]);
  return (
    <section className={`my-[10px] mb-[14px] border border-border rounded-[8px] bg-surface overflow-hidden ${open ? 'shadow-lg' : ''}`}>
      <button
        type="button"
        className="w-full flex items-center gap-2 px-[14px] py-[10px] bg-surface-el border-0 cursor-pointer text-text text-[13px] text-left hover:bg-white/[0.03]"
        onClick={() => setOpen(o => !o)}
        aria-expanded={open}
      >
        <span className="text-[11px] text-text-muted">{open ? '▾' : '▸'}</span>
        <span className="flex-1 font-semibold">{title}</span>
        {badge && (
          <span className="text-[11px] text-text-muted bg-white/[0.04] px-2 py-[2px] rounded-[10px]">{badge}</span>
        )}
      </button>
      {open && <div className="p-[14px] border-t border-border">{children}</div>}
    </section>
  );
}
